import { useState, useContext } from "react";
import { Row, Col, Typography, Carousel } from "antd";
import { useNavigate } from "react-router-dom";
import { F1, F2, F3, F6 } from "../../../assets"; // Ganti sesuai dengan path gambar Anda
import { LanguageContext } from "../../../context/Language.contex";

const { Title, Paragraph } = Typography;

export const TopPage = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const { language } = useContext(LanguageContext);

  const images = [F1, F2, F3, F6];

  return (
    <div
      style={{
        position: "relative",
        minHeight: "90vh",
        overflow: "hidden",
        width: "100%",
      }}
    >
      {/* SLIDER BACKGROUND */}
      <Carousel
        autoplay
        effect="fade"
        dots={false}
        beforeChange={(_, next) => setCurrentSlide(next)}
      >
        {images.map((img, index) => (
          <div key={index}>
            <div
              style={{
                height: "90vh",
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </div>
        ))}
      </Carousel>

      {/* INDICATOR BULAT */}
      <div
        style={{
          position: "absolute",
          bottom: 32,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 3,
          display: "flex",
          gap: 8,
        }}
      >
        {images.map((_, idx) => (
          <div
            key={idx}
            style={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: idx === currentSlide ? "#ffffff" : "#aaa",
              opacity: idx === currentSlide ? 1 : 0.5,
              transition: "all 0.3s ease",
            }}
          />
        ))}
      </div>

      {/* OVERLAY */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 1,
        }}
      />

      {/* ORNAMEN BLUR ATAS */}
      <div
        style={{
          position: "absolute",
          top: -100,
          left: -100,
          width: 300,
          height: 300,
          background: "rgba(0, 166, 225, 0.29)",
          filter: "blur(120px)",
          zIndex: 1,
        }}
      />

      {/* CONTENT */}
      <Row
        align="middle"
        justify="space-between"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
          height: "100%",
          width: "100%",
          padding: "0 5vw",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Col xs={24} md={12}>
          <div>
            <Title
              style={{
                color: "#D3E0EA",
                fontSize: "2.8rem",
                fontWeight: "700",
              }}
            >
              PT. LANGGENG BUANA JAYA
            </Title>
            <Paragraph
              style={{ fontSize: "1.1rem", color: "#fff", marginTop: 24 }}
            >
              {language[1]}
            </Paragraph>
            {/* <div style={{ marginTop: 32 }}>
              <Button
                type="primary"
                size="large"
                style={{
                  backgroundColor: "#2C74B3",
                  borderRadius: 30,
                  marginRight: 16,
                }}
                onClick={() => navigate("/umkm")}
              >
                Umkm Pilihan
              </Button>
              <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                <span style={{ color: "#D3E0EA", fontWeight: "bold" }}>
                  Hubungi Admin untuk
                </span>
                <div style={{ color: "#fff", fontSize: "0.85rem" }}>
                  Pendaftaran UMKM Anda
                </div>
              </div>
            </div> */}
          </div>
        </Col>

        <Col xs={24} md={12}></Col>
      </Row>
    </div>
  );
};
